export function scrollToTop() {
    window.scroll(0, 0);
}
